module.exports = __webpack_public_path__ + "img/mapas.189b45c3.svg";